module.exports = __webpack_public_path__ + "img/poele.fed44c29.svg";